<template>
    <b-card no-body>
      <template v-slot:header>
        <b-row>
          <b-col>
            <b-form-select :options="[{value: null, text: 'All statuses'}, 'pending', 'active', 'replied', 'finished', 'bounced', 'unsubscribed', 'auto_replied']" v-model="filter_status" class="mr-2" size='sm' style='max-width: 120px' @change="search"/>
            <b-form-select :options="step_options" v-model="filter_step" class="mr-2" size='sm' style='max-width: 100px' @change="search"/>

            <div class='d-inline-block'>
              <b-input-group size='sm' class='mr-2' style='max-width: 250px'>
                <b-form-input placeholder='Search email' v-model='filter_email'></b-form-input>
                <b-input-group-append>
                  <b-button @click="search">Go</b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </b-col>
          <b-col>
            <b-button size="sm" variant="primary float-right" :to="{name: `${collection}_create`}">Create</b-button>
            <b-button size="sm" variant="secondary float-right" class="mr-2" :to="{name: `${collection}_batch_create`}">Batch Create</b-button>
          </b-col>
        </b-row>
      </template>

      <b-table show-empty :items="items" @row-clicked="view_row" hover class="clickable" :fields="['email', 'status', 'next_step', 'next_step_date', 'created']">
        <template v-slot:cell(updated)='data'>
          {{data.value | datetime}}
        </template>
        <template v-slot:cell(created)='data'>
          {{data.value | datetime}}
        </template>
        <template v-slot:cell(next_step_date)='data'>
          {{data.value | datetime}}
        </template>
        <template v-slot:cell(next_step)='data'>
          <!-- {{steps_by_id[data.item.next_step]}} -->
          <!-- {{data.item.next_step ? data.item.next_step.id : data.item.next_step}} -->
          <span v-if="data.item.next_step && steps_by_id[data.item.next_step.id] !== undefined">{{steps_by_id[data.item.next_step.id].index + 1}} of {{sequence.steps.length}}</span>
        </template>
        <!-- <template v-slot:cell(name)='data'>
          <b-link :to="{name: collection, params: {id: data.item.id}}">{{data.value}}</b-link>
        </template> -->
      </b-table>

      <template v-slot:footer>
        <b-form inline>
          <b-button-toolbar>
            <b-button-group size="sm">
              <LoadingButton size="sm" @click="search('previous_page')" :disabled="current_page == 0" :loading="previous_page_loading">&lsaquo; Last</LoadingButton>
            </b-button-group>
            <b-button-group class="ml-2" size="sm">
              <LoadingButton size="sm" @click="search('next_page')" :disabled="items.length != page_size || no_more_results" :loading="next_page_loading">Next &rsaquo;</LoadingButton>
            </b-button-group>
          </b-button-toolbar>

          <b-form-select :options="page_size_options" v-model="page_size" @change="search" size="sm" class='ml-2'></b-form-select>
        </b-form>

      </template>
    </b-card>
</template>

<script>

import { db } from '@/main.js'
import ItemMixin from '@/mixins/Item.js'

export default {
  metaInfo: {title: 'Recipients'},
  mixins: [ItemMixin],
  props: ['profile', 'sequence'],
  // firestore: function () {
  //   return {
  //     items: db.collection('sequence').doc(this.$route.params.id).collection(this.collection).orderBy('created', 'desc')
  //   }
  // },
  data() {
    return {
      collection: 'recipient',
      filter_step: this.$route.query.step ? db.collection('sequence').doc(this.$route.params.id).collection('step').doc(this.$route.query.step) : null,
      filter_status: this.$route.query.status || null,
      filter_email: ''
    }
  },
  computed: {
    step_options() {
      let step_options = [{value: null, text: 'All steps'}]
      let i = 0
      for (let step of this.sequence.steps) {
        if (!step.id) {
          break
        }
        step_options.push({value: db.collection('sequence').doc(this.$route.params.id).collection('step').doc(step.id), text: `Step ${i+1}`})
        i++
      }

      return step_options
    },
    steps_by_id() {
      let steps_by_id = {}
      let i = 0
      for (let step of this.sequence.steps) {
        if (!step.id) {
          break
        }

        step.index = i
        // _step.index = i
        steps_by_id[step.id] = step

        i++
      }

      return steps_by_id
    }
  },
  methods: {
    view_row(item) {
      this.$router.push({name: this.collection, params: {recipient: item.id}})
    },
    async search(action) {
      this.loading = true
      let query = db.collection('sequence').doc(this.$route.params.id).collection(this.collection).orderBy('created', 'desc')
      if (action == 'next_page') {
        this.next_page_loading = true
        let last_item = this.items[this.items.length-1]
        query = query.startAfter(last_item.doc).limit(this.page_size)
        this.current_page++
      } else if (action == 'previous_page') {
        this.previous_page_loading = true
        let first_item = this.items[0]
        query = query.endBefore(first_item.doc).limitToLast(this.page_size)
        this.current_page--
      } else {
        query = query.limit(this.page_size)
        this.current_page = 0
      }

      let query_params = {}
      if (this.filter_status) {
        query = query.where('status', '==', this.filter_status)
        query_params.status = this.filter_status
      }
      if (this.filter_step) {
        query = query.where('next_step', '==', this.filter_step)
        query_params.step = this.filter_step.id
      }
      if (this.filter_email) {
        query = query.where('email', '==', this.filter_email)
      }

      if (JSON.stringify(this.$route.query) != JSON.stringify(query_params)) {
        this.$router.replace({query: query_params})
      }

      let docs = await query.get()
      if (docs.docs.length > 0 || action != 'next_page') {
        this.no_more_results = false
        this.items = []
        for (let doc of docs.docs) {
          let item = doc.data()
          item.id = doc.id
          item.doc = doc
          this.items.push(item)
        }
      } else {
        this.no_more_results = true
        this.current_page--
      }

      if (this.items.length > 0) {
        if (action != 'previous_page') {
          // Peak ahead
          let docs = await query.startAfter(this.items[this.items.length-1].doc).limit(1).get()
          if (docs.docs.length === 0) {
            this.no_more_results = true
          } else {
            this.no_more_results = false
          }
        }
      }

      this.next_page_loading = false
      this.previous_page_loading = false
      this.loading = false
    },
  },
  created() {
    this.search()
  },
}
</script>

<style scoped>

</style>
